import { t } from "@/i18n-js/instance";
import { ModalManager } from "@/react/components/Layout/ModalManagerProvider";
import { EDITOR_SELECTION_MODAL_ID } from "@/react/components/SettingsApp/Emails/components/Builder/BuilderFields/EditorSelectionModal";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Icon } from "@circle-react-shared/Icon";
import { Button } from "@circle-react-uikit/Button";
import type { SelectedCategory } from "../TemplateContents";
import { NavigationList } from "./NavigationList";

export const Sidebar = ({
  activeId,
  navigationItems,
  onClickNavItem,
}: {
  activeId: SelectedCategory;
  navigationItems: SelectedCategory[];
  onClickNavItem: (id: SelectedCategory) => void;
}) => {
  const showEditorSelectionModal = () => {
    void ModalManager.show(EDITOR_SELECTION_MODAL_ID);
  };

  return (
    <div
      className={classNames(
        "sticky top-24 ml-4 mr-6 flex w-full max-w-[272px] flex-col gap-5 pt-6",
      )}
    >
      <Button
        variant="circle"
        large
        onClick={showEditorSelectionModal}
        className="mx-[10px] flex items-center justify-center gap-2 px-4 py-2"
      >
        <span className="flex">
          <Icon type="20-plus-v2" size={20} />
        </span>
        <span>{t("settings.workflows.start_from_scratch")}</span>
      </Button>
      <div className="mx-[10px] flex flex-col gap-3.5">
        <NavigationList
          activeId={activeId}
          navigationItems={navigationItems}
          onClickNavItem={onClickNavItem}
        />
      </div>
    </div>
  );
};
